import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { cloudnativeFaqItems } from '../../data/faqs/cloudnative'
import { PageMeta } from '../../types'

const description =
  'クラウドリフト済みでも「インフラ運用コストが減らない」「データが分散したまま」という課題はありませんか。i3DESIGNはAWS認定パートナーとして、サーバーレス化・マイクロサービス化・DevOps導入・データ統合基盤構築を段階的に支援します。'

export const cloudnativePageMeta: PageMeta = {
  title: 'クラウドネイティブ移行・運用支援 | AWS認定×サーバーレス導入 | i3DESIGN',
  description,
  keyword: 'クラウドネイティブ サーバーレス AWS DevOps インフラ 運用',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/cloudnative/`,
}

const cloudnativeServiceSchema = buildServiceSchema({
  slug: 'cloudnative',
  name: 'クラウドネイティブ',
  description: cloudnativePageMeta.description,
  serviceType: 'クラウドネイティブ',
  category: 'モダンアプリケーション開発',
  offerCatalogName: 'クラウドネイティブ',
  breadcrumbName: 'クラウドネイティブ',
  offers: [
    {
      name: 'クラウドネイティブ化による開発加速と運用最適化',
      description:
        '最新のクラウド技術（サーバーレス、コンテナ、自動化、可視化）を導入し、「運用負荷とコストの削減」と「ビジネス開発への集中」を両立させる環境を構築します。',
    },
    {
      name: 'データドリブン経営を実現する「統合データ分析基盤」の構築',
      description:
        '大量のデータを安全かつ効率的に収集・加工し、誰もが直感的に分析できる環境を整備することで、迅速な意思決定と組織のデータ活用文化を醸成します。',
    },
  ],
})

export const cloudnativeSchema = withFaqPageSchema(
  cloudnativeServiceSchema,
  cloudnativePageMeta.url,
  cloudnativeFaqItems,
)
